export var modalType;
(function (modalType) {
    modalType["settings"] = "SettingModal";
    modalType["episodes"] = "EpisodesModal";
    modalType["channels"] = "ChannelsModal";
    modalType["related"] = "RelatedModal";
})(modalType || (modalType = {}));
export var SettingName;
(function (SettingName) {
    SettingName["AudioSubtitles"] = "AudioSubtitles";
    SettingName["Quality"] = "Quality";
    SettingName["none"] = "none";
})(SettingName || (SettingName = {}));
//# sourceMappingURL=modal.js.map